import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=9c4ad84a&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=9c4ad84a&scoped=true&lang=css&"
import style1 from "./Orders.vue?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/styles/beneficiary.css?vue&type=style&index=2&id=9c4ad84a&scoped=true&lang=css&"
import style3 from "./Orders.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4ad84a",
  null
  
)

export default component.exports